import type { ColumnDef } from '@tanstack/react-table';
import { columnaAcciones, columnaNumero, columnaTexto, type FormatoNumero } from '../../../globales/componentes/tabla/columnasEditables';
import type {
    ICostoBaseCapacidad,
    ICostoBaseRecorrido,
    IFactorServicio,
    IFactorVelocidadServicio,
    IIncrementoAnualServicio
} from '../../../modelos/CotizadorServicios/entidades/IParametrosServicios';

const FACTOR: FormatoNumero = { decimales: 3 };
const MONEDA: FormatoNumero = { prefijo: '$ ' };

/** Catálogo por nombre con su factor (tipo de uso, horario, entorno...). */
export const columnasFactor = (encabezadoNombre: string): ColumnDef<IFactorServicio>[] => [
    columnaAcciones<IFactorServicio>(),
    columnaTexto<IFactorServicio>('Nombre', encabezadoNombre),
    columnaNumero<IFactorServicio>('Factor', 'Factor', FACTOR)
];

/** Catálogo de velocidades con su factor. */
export const columnasVelocidad = (): ColumnDef<IFactorVelocidadServicio>[] => [
    columnaAcciones<IFactorVelocidadServicio>(),
    columnaNumero<IFactorVelocidadServicio>('Velocidad', 'Velocidad', { decimales: 2, sufijo: ' m/s' }),
    columnaNumero<IFactorVelocidadServicio>('Factor', 'Factor', FACTOR)
];

export const columnasCostoCapacidad = (): ColumnDef<ICostoBaseCapacidad>[] => [
    columnaAcciones<ICostoBaseCapacidad>(),
    columnaNumero<ICostoBaseCapacidad>('CapacidadKg', 'Capacidad hasta', { sufijo: ' kg' }),
    columnaNumero<ICostoBaseCapacidad>('Costo', 'Costo base', MONEDA)
];

export const columnasCostoRecorrido = (): ColumnDef<ICostoBaseRecorrido>[] => [
    columnaAcciones<ICostoBaseRecorrido>(),
    columnaNumero<ICostoBaseRecorrido>('RecorridoMm', 'Recorrido hasta', { sufijo: ' mm' }),
    columnaNumero<ICostoBaseRecorrido>('Costo', 'Costo base', MONEDA)
];

export const columnasIncrementoAnual = (): ColumnDef<IIncrementoAnualServicio>[] => [
    columnaAcciones<IIncrementoAnualServicio>(),
    columnaNumero<IIncrementoAnualServicio>('Anio', 'Año', { sinMiles: true }),
    columnaNumero<IIncrementoAnualServicio>('Porcentaje', 'Incremento', { decimales: 2, sufijo: ' %' })
];
